interface INPS_FORMULA {
  monthlyInvestment: number;
  age: number;
  retirementAge?: number;
  expectedRoI: number;
  lumpsumWithdrawal?: string;
  percentAnnuity?: number;
  expectedRoA?: number;
}

export const NPS_FORMULA = ({
  monthlyInvestment,
  age,
  retirementAge,
  expectedRoI,
  lumpsumWithdrawal,
}: INPS_FORMULA) => {
  const monthlyInvest = Number(monthlyInvestment);
  const currAge = Number(age);
  const retireAge = Number(retirementAge);
  const roi = Number(expectedRoI);

  if (
    monthlyInvest < 0 ||
    monthlyInvest > 1e8 ||
    currAge < 18 ||
    currAge >= retireAge ||
    roi < 1 ||
    roi > 100
  ) {
    const res = 0;
    return {
      investedAmount: res,
      maturityAmount: res,
      interestEarned: res,
      monthlyPension: res,
    };
  }

  const years = retireAge - currAge;
  const months = years * 12;
  const rate = roi / 100 / 12;

  const pensionCorpus = Math.round(
    (monthlyInvest * ((Math.pow(1 + rate, months) - 1) * (1 + rate))) / rate
  );

  const investedAmount = monthlyInvest * months;
  const interestEarned = pensionCorpus - investedAmount;

  let monthlyPension = 0;
  if (lumpsumWithdrawal === 'Yes') {
    const annuityAmount = pensionCorpus * 0.4;
    monthlyPension = Math.round(annuityAmount / 240); // Assume 20 years post retirement
  } else {
    monthlyPension = Math.round(pensionCorpus / 240);
  }

  return {
    investedAmount,
    maturityAmount: pensionCorpus,
    interestEarned,
    monthlyPension,
  };
};
